// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layer-content-newCen[data-v-731c6f4c]{margin:0 auto;margin-top:35px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
